
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { priceRulesEl } from "@common/src/utils/verify";
import t from "@common/src/i18n/t";

const finance = namespace("finance");
const base = namespace("base");
const app = namespace("app");
const setting = namespace("setting");

@Component({})
export default class CreateOtherPayment extends Vue {
  @finance.Action createOtherPayment;
  @base.Action getDictionaryList;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @setting.Action getPatternPaymentList;
  API_URL = window.API_URL;
  get breadData() {
    return [
      { name: this.$t("finance.payment-order"), path: "/finance/payment-order" },
      { name: this.$t("finance.new-bill-payment") }
    ];
  }
  payWayList: any[] = [];
  paymentFormData = {
    payeeName: "",
    paidMethod: "",
    paidAmount: "",
    paidTime: "",
    remark: ""
  };
  paymentFormRules = {
    paidMethod: [{ required: true, message: t("finance.select-mode-payment"), trigger: "change" }],
    paidAmount: [
      {
        required: true,
        message: t("finance.input-payment-amount")
      },
      { validator: this.checkPrice, trigger: "blur" }
    ],
    payeeName: [{ required: true, message: t("finance.enter-receiver"), trigger: "blur" }]
  };
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  created() {
    this.init();
  }

  submitForm(formName) {
    (this.$refs[formName] as any).validate(valid => {
      if (valid) {
        this.addOtherpayment();
      } else {
        console.log("error submit!!");
      }
    });
  }
  init() {
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = this.$safeValue(data, "data", []);
    });
  }

  async addOtherpayment() {
    this.btnStartLoading();
    this.createOtherPayment(this.paymentFormData)
      .then(() => {
        this.$message.success(this.$t("base.success") as any);
        this.$router.push(`/finance/payment-order`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
}
